import { initializeApp, FirebaseApp } from "firebase/app";
import { Analytics, getAnalytics, isSupported } from "firebase/analytics";
import { Auth, getAuth, onAuthStateChanged, User } from 'firebase/auth';

const firebaseConfig = {
  apiKey: String(process.env.GATSBY_FIREBASE_API_KEY),
  authDomain: String(process.env.GATSBY_FIREBASE_AUTH_DOMAIN),
  projectId: String(process.env.GATSBY_FIREBASE_PROJECT_ID),
  storageBucket: String(process.env.GATSBY_FIREBASE_STORAGE_BUCKET),
  storageBucketPublic: String(
    process.env.GATSBY_FIREBASE_PUBLIC_STORAGE_BUCKET,
  ),
  messagingSenderId: String(process.env.GATSBY_FIREBASE_MESSAGING_SENDER_ID),
  appId: String(process.env.GATSBY_FIREBASE_APP_ID),
  measurementId: String(process.env.GATSBY_FIREBASE_MEASUREMENT_ID),
  cloudFunctionsRegion: String(process.env.GATSBY_FIREBASE_FUNCTION_REGION),
};

let initializing = false;
export let firebaseApp: FirebaseApp | null = null;
export let analytics: Analytics | null = null;
export let auth: Auth | null = null;

// Initialize Firebase only on the client side
export const initFirebase = async () => {
  console.log("Init firebase called");
  if (typeof window !== 'undefined') {
    if (initializing) {
      console.log("Firebase already initializing, skip.");
      return firebaseApp;
    }
    console.log("Initializing firebase");
    initializing = true;

    firebaseApp = initializeApp(firebaseConfig);
    auth = getAuth(firebaseApp);    
    
    // Check if analytics is supported before initializing
    const isAnalyticsSupported = await isSupported();
    console.log("Firebase Analytics supported: ", isAnalyticsSupported)
    if (isAnalyticsSupported) {
      analytics = getAnalytics(firebaseApp);
    }

    // ==========================
    // USER CHANGE HANDLER
    // ==========================
    const handleUserChange = (user: User | null) =>{
      console.log("User change: ", {user: user});
      // if (user) {
      //   // User is signed in, see docs for a list of available properties
      //   // https://firebase.google.com/docs/reference/js/firebase.User
      //   const uid = user.uid;
      //   // ...
      // } else {
      //   // User is signed out
      //   // ...
      // }
    }
    // Regiser event hanlder function
    onAuthStateChanged(auth, handleUserChange);

    // ==========================
    // WRAP UP
    // ==========================
    return firebaseApp;
  }
  return null;
};
